
import { FSharpRef, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { TrackHistoryDto_$reflection } from "../Shared/Telematics.js";
import { today, date, addHours, now as now_1, addDays, op_Subtraction, compare, toLocalTime, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { truncate, tryFind, length, tryHead, exists, choose, reverse, toArray, empty, ofArray, map as map_1, isEmpty } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { fromDays } from "../fable_modules/fable-library-js.5.0.0-rc.2/TimeSpan.js";
import { toArray as toArray_1, unwrap, filter, orElse, defaultArg, map, bind } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { TrackerMap, TrackPoint, TrackerMarker, MarkerKind, MarkerStatus } from "./TrackerMap.js";
import { useTranslation } from "react-i18next";
import { OnTableRowClick$1, CellContent, ColumnDefinition$1 } from "./Table/Types.js";
import { createElement } from "react";
import React from "react";
import { Table } from "./Table/Table.js";
import { ModalSheet } from "../Components/ModalSheet.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { min, equals, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { InfiniteTable } from "./Table/InfiniteTable.js";
import { getHistory, useAssignedTrackers } from "../Requests/Telematics.js";
import { tryParse } from "../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { forAll, collect, map as map_2, empty as empty_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ErrorAlert, WarningAlert } from "../Components/Alert.js";
import { Button } from "../Components/Button.js";
import { DatePicker } from "../Components/DatePicker.js";
import { LabeledValue } from "../Components/Text.js";
import { Skeleton } from "../Components/Skeleton.js";

export class Period extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Today", "Hours24", "Days7", "Days30", "Custom"];
    }
}

export function Period_$reflection() {
    return union_type("Widgets.TrackerMapSection.Period", [], Period, () => [[], [], [], [], []]);
}

class HistoryState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Idle", "Loading", "Loaded", "NotSupported", "Failed"];
    }
}

function HistoryState_$reflection() {
    return union_type("Widgets.TrackerMapSection.HistoryState", [], HistoryState, () => [[], [], [["Item", TrackHistoryDto_$reflection()]], [], []]);
}

function testId(id) {
    return ["data-test-id", id];
}

function dateTime(value) {
    return toString(toLocalTime(value), "dd.MM.yyyy HH:mm");
}

export const maxRangeDays = 31;

export const maxVisiblePoints = 10;

export function hasTrackers(page) {
    if (page.Connected) {
        return !isEmpty(page.Trackers);
    }
    else {
        return false;
    }
}

export function isVisible(data) {
    const matchValue = data.data;
    if (matchValue == null) {
        if (data.error == null) {
            return false;
        }
        else {
            return true;
        }
    }
    else {
        return hasTrackers(matchValue);
    }
}

export function customRangeError(customFrom, customTo) {
    let from_1;
    let matchResult, from_2, until_2, from_3, until_3;
    if (customFrom != null) {
        if (customTo != null) {
            if (compare(customFrom, customTo) > 0) {
                matchResult = 0;
                from_2 = customFrom;
                until_2 = customTo;
            }
            else if ((from_1 = customFrom, op_Subtraction(addDays(customTo, 1), from_1) > fromDays(maxRangeDays))) {
                matchResult = 1;
                from_3 = customFrom;
                until_3 = customTo;
            }
            else {
                matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0:
            return "validation.telematics.history_range_invalid";
        case 1:
            return "validation.telematics.history_range_too_long";
        default:
            return undefined;
    }
}

function rangeOf(period, customFrom, customTo) {
    const now = now_1();
    switch (period.tag) {
        case 1:
            return [addHours(now, -24), now];
        case 2:
            return [addDays(now, -7), now];
        case 3:
            return [addDays(now, -30), now];
        case 4: {
            const matchValue = customRangeError(customFrom, customTo);
            let matchResult, from, until;
            if (customFrom != null) {
                if (customTo != null) {
                    if (matchValue == null) {
                        matchResult = 0;
                        from = customFrom;
                        until = customTo;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return [from, addDays(until, 1)];
                default:
                    return undefined;
            }
        }
        default:
            return [date(now), now];
    }
}

function markerOf(props, tracker) {
    return bind((status) => map((position) => (new TrackerMarker(tracker.TrackerId, tracker.Name, position.Latitude, position.Longitude, (status.Disabled ? true : !status.Online) ? (new MarkerStatus(1, [])) : ((position.Fix === "stale") ? (new MarkerStatus(2, [])) : (new MarkerStatus(0, []))), (props.EntityType.tag === 1) ? (new MarkerKind(1, [])) : (new MarkerKind(0, [])), position.AccuracyMeters, position.Heading)), status.Position), tracker.Status);
}

function trackOf(history) {
    return map_1((point) => (new TrackPoint(point.Latitude, point.Longitude, point.RecordedAt)), history.Points);
}

const periods = ofArray([[new Period(0, []), "today"], [new Period(1, []), "last_24h"], [new Period(2, []), "last_7_days"], [new Period(3, []), "last_30_days"], [new Period(4, []), "custom"]]);

function useHistoryColumns() {
    const patternInput = useTranslation();
    const t = patternInput[0];
    const i18n = patternInput[1];
    const column = (id, header, columnType, accessor) => (new ColumnDefinition$1(id, "", header, accessor, "none", columnType));
    return [column("time", t("telematics.map.time"), "dateTime", (point) => (new CellContent(9, [point.RecordedAt]))), column("speed", t("telematics.map.speed"), "text", (point_1) => (new CellContent(0, [defaultArg(map((speed) => {
        const arg_1 = {
            value: speed,
        };
        return i18n.t("telematics.map.speed_value", arg_1);
    }, point_1.SpeedKmh), "")]))), column("accuracy", t("telematics.map.accuracy"), "text", (point_2) => (new CellContent(0, [defaultArg(map((meters) => {
        const arg_3 = {
            value: meters,
        };
        return i18n.t("telematics.map.accuracy_value", arg_3);
    }, point_2.AccuracyMeters), "")])))];
}

function HistoryTable(props) {
    return createElement(Table, {
        ColumnDefinitions: useHistoryColumns(),
        Controls: empty(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["time", "desc"],
            Fullscreen: false,
            GlobalSearch: false,
            OnRowClick: new OnTableRowClick$1(0, [props.OnFocus]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "tracker-history",
        TableRows: toArray(props.Points),
    });
}

function HistoryModal(props) {
    let elems;
    const columns = useHistoryColumns();
    return createElement(ModalSheet, {
        CloseButtonTestId: "tracker-map-history-modal-close",
        Content: reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "px-4", "pb-4"])], testId("tracker-map-history-modal"), (elems = [createElement(InfiniteTable, {
            ColumnDefinitions: columns,
            Controls: empty(),
            Options: {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["time", "desc"],
                Fullscreen: false,
                GlobalSearch: false,
                OnRowClick: new OnTableRowClick$1(0, [props.OnFocus]),
                RowSelection: "disabled",
                SaveTableConfiguration: false,
                WithQueryParameters: false,
            },
            TableKey: "tracker-history-all",
            TableRows: toArray(reverse(props.Points)),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: props.Title,
    });
}

export function TrackerMapSection(props) {
    let elems_12, elems, elems_1;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const i18n = patternInput[1];
    const data = useAssignedTrackers(props.EntityType, props.EntityId);
    const patternInput_1 = reactApi.useState(undefined);
    const setSelected = patternInput_1[1];
    const patternInput_2 = reactApi.useState(new Period(0, []));
    const period = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const customFrom = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const customTo = patternInput_4[0];
    const patternInput_5 = reactApi.useState(new HistoryState(0, []));
    const setHistory = patternInput_5[1];
    const history = patternInput_5[0];
    const patternInput_6 = reactApi.useState(false);
    const setHistoryModalOpen = patternInput_6[1];
    const patternInput_7 = reactApi.useState(true);
    const setHistorySupported = patternInput_7[1];
    const historySupported = patternInput_7[0];
    const patternInput_8 = reactApi.useState(undefined);
    const requestCounter = reactApi.useRef(0);
    const trackers = defaultArg(map((page) => page.Trackers, data.data), empty());
    const markers = choose((tracker) => markerOf(props, tracker), trackers);
    const effectiveSelected = orElse(filter((id) => exists((tracker_1) => (tracker_1.TrackerId === id), trackers), patternInput_1[0]), map((tracker_2) => tracker_2.TrackerId, tryHead(trackers)));
    const dependencies = [effectiveSelected];
    reactApi.useEffect(() => {
        setHistorySupported(true);
    }, dependencies);
    const dependencies_2 = [effectiveSelected, period, customFrom, customTo, historySupported];
    reactApi.useEffect(() => {
        const matchValue_1 = bind((id_1) => {
            let matchValue;
            let outArg = "00000000-0000-0000-0000-000000000000";
            matchValue = [tryParse(id_1, new FSharpRef(() => outArg, (v) => {
                outArg = v;
            })), outArg];
            if (matchValue[0]) {
                return matchValue[1];
            }
            else {
                return undefined;
            }
        }, effectiveSelected);
        const matchValue_2 = rangeOf(period, customFrom, customTo);
        let matchResult, from, trackerId, until;
        if (matchValue_1 != null) {
            if (matchValue_2 != null) {
                if (historySupported) {
                    matchResult = 0;
                    from = matchValue_2[0];
                    trackerId = matchValue_1;
                    until = matchValue_2[1];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                requestCounter.current = (requestCounter.current + 1);
                const request = requestCounter.current | 0;
                const isCurrent = () => (requestCounter.current === request);
                setHistoryModalOpen(false);
                setHistory(new HistoryState(1, []));
                let pr_2;
                let pr_1;
                const pr = getHistory(trackerId, from, until);
                pr_1 = (pr.then((result) => {
                    const matchValue_4 = isCurrent();
                    let matchResult_1, dto;
                    if (result.tag === 1) {
                        if (matchValue_4) {
                            matchResult_1 = 1;
                        }
                        else {
                            matchResult_1 = 2;
                        }
                    }
                    else if (matchValue_4) {
                        matchResult_1 = 0;
                        dto = result.fields[0];
                    }
                    else {
                        matchResult_1 = 2;
                    }
                    switch (matchResult_1) {
                        case 0: {
                            setHistory(new HistoryState(2, [dto]));
                            break;
                        }
                        case 1: {
                            setHistorySupported(false);
                            setHistory(new HistoryState(3, []));
                            break;
                        }
                        case 2: {
                            break;
                        }
                    }
                }));
                pr_2 = (pr_1.then(void 0, ((_arg) => {
                    if (isCurrent()) {
                        setHistory(new HistoryState(4, []));
                    }
                })));
                pr_2.then();
                break;
            }
            case 1: {
                requestCounter.current = (requestCounter.current + 1);
                if (historySupported) {
                    setHistory(new HistoryState(0, []));
                }
                break;
            }
        }
    }, dependencies_2);
    const track = (history.tag === 2) ? (equals(history.fields[0].TrackerId, effectiveSelected) ? trackOf(history.fields[0]) : undefined) : undefined;
    const matchValue_6 = data.data;
    if (matchValue_6 != null) {
        if (!hasTrackers(matchValue_6)) {
            const page_2 = matchValue_6;
            return defaultOf();
        }
        else {
            const page_3 = matchValue_6;
            return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4", "p-8"])], testId("tracker-map-section"), (elems_12 = toList(delay(() => append(!page_3.ProviderAvailable ? singleton(createElement(WarningAlert, {
                Label: t("telematics.map.provider_unavailable"),
            })) : empty_1(), delay(() => {
                let elems_2;
                return append((length(page_3.Trackers) > 1) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2"])], (elems_2 = toList(delay(() => map_2((tracker_3) => {
                    let Variant_1;
                    return createElement(Button, (Variant_1 = (equals(effectiveSelected, tracker_3.TrackerId) ? "primary" : "secondary"), {
                        ComponentState: "enabled",
                        Label: tracker_3.Name,
                        OnClick: () => {
                            setSelected(tracker_3.TrackerId);
                        },
                        TestId: concat("tracker-map-select-", ...tracker_3.TrackerId),
                        Variant: Variant_1,
                    }));
                }, page_3.Trackers))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty_1(), delay(() => {
                    let elems_5;
                    return append(historySupported ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "items-end", "gap-2"])], testId("tracker-map-period"), (elems_5 = toList(delay(() => append(collect((matchValue_7) => {
                        let value_1, key, Label, Variant;
                        return singleton((value_1 = matchValue_7[0], (key = matchValue_7[1], createElement(Button, (Label = t(concat("telematics.map.", ...key)), (Variant = (equals(period, value_1) ? "primary" : "secondary"), {
                            ComponentState: "enabled",
                            Label: Label,
                            OnClick: () => {
                                patternInput_2[1](value_1);
                            },
                            TestId: concat("tracker-map-period-", ...key),
                            Variant: Variant,
                        }))))));
                    }, periods), delay(() => {
                        let elems_3;
                        return equals(period, new Period(4, [])) ? append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["w-40"])], (elems_3 = [createElement(DatePicker, {
                            ComponentState: "enabled",
                            IsClearable: true,
                            Label: t("telematics.map.from"),
                            MaxDate: today(),
                            OnChange: patternInput_3[1],
                            TestId: "tracker-map-custom-from",
                            Value: unwrap(customFrom),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                            let elems_4;
                            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["w-40"])], (elems_4 = [createElement(DatePicker, {
                                ComponentState: "enabled",
                                IsClearable: true,
                                Label: t("telematics.map.to"),
                                MaxDate: defaultArg(map((from_1) => min((x, y) => (compare(x, y) | 0), today(), addDays(from_1, maxRangeDays - 1)), customFrom), today()),
                                MinDate: unwrap(customFrom),
                                OnChange: patternInput_4[1],
                                TestId: "tracker-map-custom-to",
                                ValidationMessage: unwrap(map(t, customRangeError(customFrom, customTo))),
                                Value: unwrap(customTo),
                            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                        })) : empty_1();
                    })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty_1(), delay(() => {
                        let elems_8;
                        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "lg:flex-row", "gap-4"])], (elems_8 = toList(delay(() => {
                            let elems_6;
                            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "min-w-0"])], (elems_6 = toList(delay(() => ((isEmpty(markers) && forAll(isEmpty, toArray_1(track))) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["text-sm", "text-gray-600"])], testId("tracker-map-no-position"), ["children", t("telematics.map.no_position")]])))) : singleton(TrackerMap({
                                Cluster: false,
                                Focus: unwrap(patternInput_8[0]),
                                Height: 360,
                                LocationMarkers: empty(),
                                Markers: markers,
                                OnSelect: (id_2) => {
                                    setSelected(id_2);
                                },
                                OnSelectLocation: (value_22) => {
                                },
                                Selected: unwrap(effectiveSelected),
                                Track: unwrap(track),
                            }))))), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                                let elems_7;
                                const matchValue_8 = bind((id_3) => tryFind((tracker_4) => (tracker_4.TrackerId === id_3), trackers), effectiveSelected);
                                if (matchValue_8 == null) {
                                    return singleton(defaultOf());
                                }
                                else {
                                    const tracker_5 = matchValue_8;
                                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["w-full", "lg:w-80"])], testId("tracker-map-details"), (elems_7 = [LabeledValue({
                                        Label: t("general.tracker"),
                                        Value: tracker_5.Name,
                                    }), LabeledValue({
                                        Label: t("telematics.trackers.last_seen"),
                                        Value: defaultArg(map(dateTime, bind((status) => status.LastSeenAt, tracker_5.Status)), "–"),
                                    }), LabeledValue({
                                        Label: t("telematics.map.accuracy"),
                                        Value: defaultArg(map((meters) => {
                                            const arg_1 = {
                                                meters: meters,
                                            };
                                            return i18n.t("telematics.trackers.accuracy", arg_1);
                                        }, bind((position) => position.AccuracyMeters, bind((status_1) => status_1.Position, tracker_5.Status))), "–"),
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))));
                                }
                            }));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                            let elems_9, elems_11;
                            const matchValue_9 = history;
                            switch (matchValue_9.tag) {
                                case 1:
                                    return singleton(reactElement("div", {
                                        className: join(" ", ["text-sm", "text-gray-500"]),
                                        children: t("telematics.map.history_loading"),
                                    }));
                                case 3:
                                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["text-sm", "text-gray-600"])], testId("tracker-map-history-not-supported"), ["children", t("telematics.map.history_not_supported")]]))));
                                case 4:
                                    return singleton(reactElement("div", createObj(ofArray([testId("tracker-map-history-failed"), (elems_9 = [createElement(ErrorAlert, {
                                        Label: t("telematics.map.history_failed"),
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))));
                                case 2: {
                                    const dto_3 = matchValue_9.fields[0];
                                    let historyTitle;
                                    let arg_3;
                                    const from_2 = dateTime(dto_3.From);
                                    const to = dateTime(dto_3.To);
                                    arg_3 = {
                                        count: length(dto_3.Points),
                                        from: from_2,
                                        to: to,
                                    };
                                    historyTitle = (i18n.t("telematics.map.history_title", arg_3));
                                    const focusPoint = (point) => {
                                        patternInput_8[1]([point.Latitude, point.Longitude]);
                                    };
                                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], testId("tracker-map-history"), (elems_11 = toList(delay(() => append(singleton(reactElement("span", {
                                        className: join(" ", ["text-sm", "font-semibold"]),
                                        children: historyTitle,
                                    })), delay(() => append((dto_3.Resolution === "hourly") ? singleton(reactElement("span", {
                                        className: join(" ", ["text-sm", "text-gray-600"]),
                                        children: t("telematics.map.resolution_hourly"),
                                    })) : empty_1(), delay(() => append(isEmpty(dto_3.Points) ? singleton(reactElement("span", createObj(ofArray([["className", join(" ", ["text-sm", "text-gray-600"])], testId("tracker-map-no-points"), ["children", t("telematics.map.no_points")]])))) : singleton(createElement(HistoryTable, {
                                        OnFocus: focusPoint,
                                        Points: truncate(maxVisiblePoints, reverse(dto_3.Points)),
                                    })), delay(() => {
                                        let elems_10;
                                        return (length(dto_3.Points) > maxVisiblePoints) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-2"])], (elems_10 = [createElement(Button, {
                                            ComponentState: "enabled",
                                            Label: t("general.show_more_data"),
                                            OnClick: () => {
                                                setHistoryModalOpen(true);
                                            },
                                            TestId: "tracker-map-history-show-more",
                                            Variant: "blueButton",
                                        }), createElement(HistoryModal, {
                                            IsOpen: patternInput_6[0],
                                            OnClose: () => {
                                                setHistoryModalOpen(false);
                                            },
                                            OnFocus: (point_1) => {
                                                focusPoint(point_1);
                                                setHistoryModalOpen(false);
                                            },
                                            Points: dto_3.Points,
                                            Title: historyTitle,
                                        })], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))) : empty_1();
                                    })))))))), ["children", reactApi.Children.toArray(Array.from(elems_11))])]))));
                                }
                                default:
                                    return singleton(defaultOf());
                            }
                        }));
                    }));
                }));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_12))])])));
        }
    }
    else if (data.error != null) {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["p-8"])], testId("tracker-map-load-failed"), (elems = [createElement(ErrorAlert, {
            Label: t("telematics.map.load_failed"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["p-8"])], (elems_1 = [createElement(Skeleton, {
            Variant: "normal",
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }
}

